import { makeStyles } from "@material-ui/core/styles";
import { BookmarkBorder, BookmarkOutlined } from "@material-ui/icons";
import { Tooltip, useTheme } from "@mui/material";

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { TestContext } from "../contexts/TestContext";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
  tooltip: {
    fontSize: "1.5em",
  },
}));

export default function Bookmark({ question }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const { setMarForkReview, setSelectEvent, selectEvent } = useContext(TestContext);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const handlePopoverOpen = (event) => {
    setSelectEvent(selectEvent === true ? false : true)
    setAnchorEl(event.currentTarget);
    setMarForkReview(event.currentTarget)
    question.markForReview = !question.markForReview
    if (question.markForReview) {

      question.markForReviewCount = question.markForReviewCount + 1;
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title={t('Bookmark')} classes={{ tooltip: classes.tooltip }} placement="bottom">
        {!question.markForReview ?
          <BookmarkBorder
            style={{ color: '#594e4e', fontSize: 30 }}
            onClick={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          /> :
          <BookmarkOutlined
            style={{ color: '#594e4e', fontSize: 30 }}
            onClick={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          />
        }
      </Tooltip>
    </>
  );
}
